export default "__VITE_ASSET__8Jdj9qQ4eJq3labUJOvRYQ__"